import { render, staticRenderFns } from "./nbaItem.vue?vue&type=template&id=5db9aa9b&scoped=true"
import script from "./nbaItem.vue?vue&type=script&lang=js"
export * from "./nbaItem.vue?vue&type=script&lang=js"
import style0 from "./nbaItem.vue?vue&type=style&index=0&id=5db9aa9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9aa9b",
  null
  
)

export default component.exports